import LucidMascot from "@/assets/images/AishaMoonwalk.gif";
import { CircleNotch } from "@phosphor-icons/react/dist/ssr";
import Image from "next/legacy/image";

const LoadingContent = () => {
  return (
    <span className='flex flex-col w-full items-center bg-white/5 overflow-hidden justify-center gap-0 text-center border border-dashed border-white/10 rounded-2xl min-h-[50vh]'>
      <div className='relative flex-shrink-0 h-32 lg:h-40 aspect-square'>
        <Image
          src={LucidMascot.src}
          alt=''
          layout={"fill"}
          className='object-contain'
        />
      </div>
      <span className='inline-flex items-center gap-2 mt-4 opacity-40'>
        <CircleNotch className='animate-spin' />
        <span>Loading Content...</span>
      </span>
    </span>
  );
};

export default LoadingContent;
